import React, {useState} from 'react'
import {resetPasswordValid} from '../../../Utils/_helpers/ValidationSchema'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import {data} from 'jquery'
import {resetPassword, updatePassword} from '../AllCellCastUser/UserListSlice/UserListSlice'
import {useDispatch} from 'react-redux'
import {Navigate, useLocation, useNavigate} from 'react-router-dom'

const ResetPassword = () => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const param = useLocation()
  const searchParams = new URLSearchParams(param.search)

  // Get the 'email' and 'code' parameters from the URL
  const email = searchParams.get('email')
  const code = searchParams.get('code')

  // Do something with the 'email' and 'code' values

  return (
    <>
      <div className='form w-100 py-20'>
        {/* begin::Heading */}
        <div className='card-body'>
          <div className='mb-10 text-start'>
            <a href='#' className='mb-6 d-flex flex-center'>
              <h1 className='text-dark mb-3 fs-3x' data-kt-translate='sign-in-title'>
                Create New password
              </h1>
            </a>
          </div>
          <Formik
            initialValues={{
              password: '',
              confirmPassword: '',
            }}
            validationSchema={resetPasswordValid}
            onSubmit={(val: any) => {
              dispatch(resetPassword({password: val?.password, code, email}))
              navigate('/auth')
            }}
          >
            {() => (
              <Form>
                <div>
                  <label htmlFor='password' className='form-label text-dark fs-6 mb-0'>
                    Password
                  </label>
                  <Field
                    className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    type='password'
                    id='password'
                    name='password'
                  />
                  <ErrorMessage name='password'>
                    {(msg: string) => <span className='text-danger'>{msg}</span>}
                  </ErrorMessage>
                </div>
                <div className='my-6'>
                  <label htmlFor='confirmPassword' className='form-label text-dark fs-6 mb-0'>
                    Confirm Password
                  </label>
                  <Field
                    className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    type='password'
                    id='confirmPassword'
                    name='confirmPassword'
                  />
                  <ErrorMessage name='confirmPassword'>
                    {(msg: string) => <span className='text-danger'>{msg}</span>}
                  </ErrorMessage>
                </div>
                <button className='btn btn-primary'>Create</button>
              </Form>
            )}
          </Formik>
          {/* 
          <div className='mb-10 text-start'>
            <a href='#' className='mb-12 d-flex flex-center'>
              <h1 className='text-dark mb-3 fs-3x' data-kt-translate='sign-in-title'>
                Create New password
              </h1>
            </a>
          </div>
          <div className='fv-row mb-8'>
            <label className='form-label fs-6 fw-bolder text-dark'>New Password</label>
            <input className='form-control-solid form-control form-control-sm' />
          </div>
          <div className='fv-row mb-8'>
            <label className='form-label fs-6 fw-bolder text-dark'>confirm Password</label>
            <input className='form-control-solid form-control form-control-sm' />
          </div> */}

          {/* end::Form group */}

          {/* begin::Action */}
          {/* <div className='d-flex flex-stack'>
            <button
              type='submit'
              id='kt_sign_in_submit'
              className='btn btn-primary me-2 flex-shrink-0'
            >
              {!loading && (
                <span className='indicator-label' data-kt-translate='sign-in-submit'>
                  create
                </span>
              )}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div> */}
        </div>
      </div>
    </>
  )
}

export default ResetPassword
